<template>
    <div class="licensing-merchandising">

        <div class="years row" :style='{ gridTemplateColumns: `${labelWidth} repeat(${columns}, 1fr)` }'>
            <h5 class='label'></h5>
            <div class='item' v-for='year in years' :key='year'>{{year}}</div>
        </div>

        <div class="estimated row" :style='{ gridTemplateColumns: `${labelWidth} repeat(${columns}, 1fr)` }'>
            <h5 class='label'>Estimated Licensing &amp; Merch</h5>
            <template v-for='n in 5'>
                <div class='item' v-for='(item, idx) in ["Wholesale", "Royalty"]' :key='Math.random()'>{{item}}</div>
            </template>
        </div>

        <div class="apparel row" :style='{ gridTemplateColumns: `${labelWidth} repeat(${columns}, 1fr)` }'>
            <h5 class='label'>Total Apparel</h5>
            <div class='item' v-for='item in totalApparel' :key='item'>{{item}}</div>
        </div>

        <div class="electronics-interactive row" :style='{ gridTemplateColumns: `${labelWidth} repeat(${columns}, 1fr)` }'>
            <h5 class='label'>Total Electronics &amp; Interactive</h5>
            <div class='item' v-for='item in electronicsInteractive' :key='item'>{{item}}</div>
        </div>

        <div class="health-beauty row" :style='{ gridTemplateColumns: `${labelWidth} repeat(${columns}, 1fr)` }'>
            <h5 class='label'>Total Health &amp; Beauty</h5>
            <div class='item' v-for='(item, idx) in healthBeauty' :key='"healthBeauty" + idx'>{{item}}</div>
        </div>

        <div class="toy-specialty row" :style='{ gridTemplateColumns: `${labelWidth} repeat(${columns}, 1fr)` }'>
            <h5 class='label'>Total Toy &amp; Specialty</h5>
            <div class='item' v-for='item in toySpecialty' :key='"toySpecialty" + item'>{{item}}</div>
        </div>

        <div class="stationary-publishing row" :style='{ gridTemplateColumns: `${labelWidth} repeat(${columns}, 1fr)` }'>
            <h5 class='label'>Total Stationery &amp; Publishing</h5>
            <div class='item' v-for='(item, idx) in stationaryPublishing' :key='"stationaryPublishing" + idx'>{{item}}</div>
        </div>

        <div class="col-totals row" :style='{ gridTemplateColumns: `${labelWidth} repeat(${columns}, 1fr)` }'>
            <h5 class='label'></h5>
            <div class='item' v-for='item in colTotals' :key='"colTotals" + item'>{{item}}</div>
        </div>

        


    </div>
</template>

<script>
export default {
    data() {
        return {
            labelWidth: '300px',
            columns: 10,
            years: [ 'Year 1 ', 'Year 2', 'Year 3', 'Year 4', 'Year 5' ],
            totalApparel: ['$1,450,000', '$145,000', '$3,175,000', '$317,500', '$8,775,000', '$877,500', '$47,200,000', '$4,720,000',  '$166,502,381', '$16,650,238'],
            electronicsInteractive: ['$25,000', '$2,500',  '$425,000',  '$42,500',  '$1,225,000',  '$122,500',  '$1,450,000','$145,000',  '$2,400,000',  '$240,000'],
            healthBeauty: ['$—','$-','$50,000 ','$4,000 ','$200,000 ','$20,000 ','$200,000 ','$20,000 ','$800,000 ','$80,000'],
            toySpecialty: ['$180,000','$18,000','$1,750,000','$175,000','$7,300,000','$730,000','$7,371,610','$737,161','$6,550,000','$655,000',],
            stationaryPublishing: ['$275,000','$27,500','$500,000','$50,000','$850,000','$85,000','$850,000','$85,000','$1,250,000','$125,000',],
            colTotals: ['$1,930,000','$193,000','$5,900,000','$589,000','$18,350,000','$1,835,000','$57,071,610','$5,707,161','$177,502,381','$17,750,238']
        }
    }
}
</script>

<style lang='scss'>

@import '../styles/mixins';
@import '../styles/vars';

.licensing-merchandising {
    display: grid;
    height: 100%;
}

.row {
    display: grid;
    grid-gap: 1px;
    margin: 0 0 1px;
}

.item {
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: black;
}

.label {
    margin: 0;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    padding: 0 0 0 10%;
    font-weight: 800;
    grid-column: 1/2;
}

.item,
.label {
    @include fluid-type(320px, 1920px, 10px, 14px);
}

/*.years .label { background: rgba($color-green, 0.3); }*/
.years .item,
.col-totals .item { background: rgba($color-gray, 0.6); }

.years.row .item,
.col-totals .item {
    font-weight: 800;   
}


.years .item:nth-of-type(1) { grid-column: 2/4 }
.years .item:nth-of-type(2) { grid-column: 4/6 }
.years .item:nth-of-type(3) { grid-column: 6/8 }
.years .item:nth-of-type(4) { grid-column: 8/10 }
.years .item:nth-of-type(5) { grid-column: 10/12 }

.estimated .label { background: rgba($color-gray, 0.3); }
.estimated .item { background: rgba($color-gray, 0.3); }

.apparel .label { background: rgba($color-blue, 0.3); }
.apparel .item { background: rgba($color-blue, 0.3); }

.electronics-interactive .label { background: rgba($color-green, 0.3); }
.electronics-interactive .item { background: rgba($color-green, 0.3); }

.health-beauty .label { background: rgba($color-gold, 0.3); }
.health-beauty .item { background: rgba($color-gold, 0.3); }

.toy-specialty .label { background: rgba($color-orange, 0.3); }
.toy-specialty .item { background: rgba($color-orange, 0.3); }

.stationary-publishing .label { background: rgba($color-cyan, 0.3); }
.stationary-publishing .item { background: rgba($color-cyan, 0.3); }

/*$color-blue: #4a70e3;
$color-cyan: #8eeaef;
$color-gold: #f7c55c;
$color-gray: #d0cece;
$color-orange: #ef6943;
$color-green: #7ad5b3;*/
</style>


// WEBPACK FOOTER //
// src/components/LicensingMerchandising.vue